/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedPillsIcon24Solid = forwardRef('MedPillsIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.39 17.2a4.525 4.525 0 0 1 0-6.4l8.12-8.12a4.525 4.525 0 0 1 6.4 6.4L8.79 17.2a4.525 4.525 0 0 1-6.4 0Zm6.003-9.574 3.57 3.571 3.533-3.532a2.525 2.525 0 1 0-3.571-3.571L8.393 7.626Z" }),
        React.createElement("path", { d: "M17.5 22a4.479 4.479 0 0 1-2.607-.832l6.275-6.276A4.5 4.5 0 0 1 17.5 22Z" }),
        React.createElement("path", { d: "M17.5 13a4.48 4.48 0 0 1 2.607.832l-6.275 6.275A4.5 4.5 0 0 1 17.5 13Z" })));
});
